import React from "react";
import PropTypes from "prop-types";
import InfoIcon from "../../components/InfoIcon";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import TipBox from "../../components/TipBox";

const SubTotalRow = ({ columns, subtotalColumns, data, hiddenColumns }) => {
  const { t } = useTranslation();
  if (!data || data.length === 0) {
    return null;
  }

  const calculateSubtotal = (accessor) => {
    return data.reduce((sum, row) => sum + (parseFloat(row[accessor]) || 0), 0);
  };

  const hasNullValues = (accessor) => {
    return data.some((row) => row[accessor] === null || row[accessor] === "");
  };

  return (
    <tfoot>
      <tr className="subtotal-row">
        {columns.map((column) => (
          <td
            className="subtotal-exists"
            key={column.accessor}
            style={{
              width: hiddenColumns.includes(column.accessor) ? "30px" : "auto",
              padding: hiddenColumns.includes(column.accessor)
                ? "0 5px"
                : "8px",
              textAlign: "center",
              position: "relative",
            }}
          >
            {!hiddenColumns.includes(column.accessor) &&
              subtotalColumns[column.accessor] && (
                <>
                  <span className="subtotal-span">
                    {column.subtotalFixed
                      ? calculateSubtotal(column.accessor).toFixed(2) +
                        " " +
                        column.subtotalUnit
                      : calculateSubtotal(column.accessor) +
                        " " +
                        column.subtotalUnit}
                  </span>
                  {hasNullValues(column.accessor) && (
                    <TipBox
                      title={"Tip"}
                      customStyle={{ margin: "0 auto" }}
                      message={t("TIP_NO_MONETARY")}
                    >
                      <div
                        style={{
                          position: "absolute",
                          bottom: "-13px",
                          left: "40%",
                        }}
                      >
                        <IconButton size="small">
                          <InfoIcon />
                        </IconButton>
                      </div>
                    </TipBox>
                  )}
                </>
              )}
          </td>
        ))}
        <td></td>
      </tr>
    </tfoot>
  );
};

SubTotalRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  subtotalColumns: PropTypes.objectOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  hiddenColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SubTotalRow;
